import { Client } from "../models/basic/client";
import { AbstractService, Filters } from "./abstract-service";
import { URLS } from "./app-urls";

export type ClientFilter = Filters & {
    search: string;
    active: string;
};

export class ClientService extends AbstractService<Client> {

    constructor() {
        super(URLS.CLIENT);
    }

    override processFilters = (filters?: Filters) : Filters | undefined => {
        const processedFilter = {
            ...filters
        };

        if(processedFilter.active) {
            if(processedFilter.active === "0") {
                delete processedFilter.active;
            } else {
                processedFilter.active = processedFilter.active === "active";
            }
        }

        return processedFilter;
    }

}
